module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("卡券管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("商品券核销明细")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel down1"
  }, [_c('div', {
    staticClass: "panel-header panel-header__auto"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "formrules": _vm.formrules
    }
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("时间")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "dateRangeValue"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "editable": false,
      "placeholder": "选择日期范围",
      "size": "small",
      "clearable": false
    },
    model: {
      value: (_vm.form.dateRangeValue),
      callback: function($$v) {
        _vm.$set(_vm.form, "dateRangeValue", $$v)
      },
      expression: "form.dateRangeValue"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "choosetime"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeTime
    },
    model: {
      value: (_vm.form.choosetime),
      callback: function($$v) {
        _vm.$set(_vm.form, "choosetime", $$v)
      },
      expression: "form.choosetime"
    }
  }, _vm._l((_vm.choosetimes), function(item) {
    return _c('el-radio-button', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("券码查询")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "ticket_code"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-310",
    attrs: {
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.form.ticket_code),
      callback: function($$v) {
        _vm.$set(_vm.form, "ticket_code", $$v)
      },
      expression: "form.ticket_code"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "ticket_name"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-200",
    attrs: {
      "type": "text",
      "size": "small"
    },
    model: {
      value: (_vm.form.ticket_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "ticket_name", $$v)
      },
      expression: "form.ticket_name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("核销交易号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "writeoff_syssn"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-200",
    attrs: {
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.form.writeoff_syssn),
      callback: function($$v) {
        _vm.$set(_vm.form, "writeoff_syssn", $$v)
      },
      expression: "form.writeoff_syssn"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-select__wrapper orderno_nowrap"
  }, [_c('span', {
    staticClass: "panel-select__desc"
  }, [_vm._v("商品订单号")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "goods_syssn"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-200",
    attrs: {
      "type": "number",
      "size": "small"
    },
    model: {
      value: (_vm.form.goods_syssn),
      callback: function($$v) {
        _vm.$set(_vm.form, "goods_syssn", $$v)
      },
      expression: "form.goods_syssn"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group"
  }, [_c('div', {
    staticClass: "panel-select-group-btn",
    staticStyle: {
      "padding-left": "70px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-select-group-btn"
  }, [_c('el-button', {
    staticClass: "primary-btn",
    staticStyle: {
      "width": "102px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.search()
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn",
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("重置")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.transData.records,
      "row-class-name": "el-table__row_fix"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "sysdtm",
      "min-width": "100px",
      "label": "时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.create_time))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "trade_id",
      "min-width": "130",
      "label": "核销交易号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "券码"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.ticket_code))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品订单号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.order_id))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goods_name))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.status_str))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "门店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.shop_name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作员"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.userid))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.current_price)) + "元")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "平台补贴",
      "min-width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.koubei_subsidy_amt)) + "元")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商家实收",
      "min-width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.receipt_amt)) + "元")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商家优惠"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("formatCurrency")(scope.row.discount_amt)) + "元")]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.transData.total >= 10) ? _c('div', {
    staticClass: "pagination_wrapper"
  }, [_c('el-pagination', {
    ref: "page",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.transData.total,
      "current-page": _vm.currentPage
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.currentChange
    }
  })], 1) : _c('div', {
    staticClass: "table_placeholder"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-336ec3aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/writeofflist/writeofflist.vue
// module id = 807
// module chunks = 1